"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var recoil_1 = require("recoil");
var react_router_dom_1 = require("react-router-dom");
var components_1 = require("@/components");
var Styled = __importStar(require("./ActivityScoreDetail.styled"));
var hooks_1 = require("@/hooks");
var constants_1 = require("@/constants");
var ActivityScore_1 = require("@/components/ActivityScore");
var Button_component_1 = require("@/components/common/Button/Button.component");
var plus_16_svg_1 = __importDefault(require("@/assets/svg/plus-16.svg"));
var member_1 = require("@/store/member");
var store_1 = require("@/store");
var utils_1 = require("@/utils");
var ActivityScoreDetail = function () {
    var handleGoBack = (0, hooks_1.useHistory)().handleGoBack;
    var _a = (0, react_router_dom_1.useParams)(), generationNumberParam = _a.generationNumber, memberIdParam = _a.memberId;
    var handleApplyActivityScoreModal = (0, recoil_1.useSetRecoilState)((0, store_1.$modalByStorage)(store_1.ModalKey.applyActivityScoreModalDialog));
    var handleActivityScoreModal = (0, recoil_1.useSetRecoilState)((0, store_1.$modalByStorage)(store_1.ModalKey.activityScoreModalDialog));
    var columns = [
        {
            title: '',
            widthRatio: '7%',
            accessor: 'scoreType',
            renderCustomCell: function (_a) {
                var cellValue = _a.cellValue;
                return ((0, jsx_runtime_1.jsx)(Styled.IconWrapper, { children: (0, jsx_runtime_1.jsx)(ActivityScore_1.Icon, { type: cellValue }, void 0) }, void 0));
            },
        },
        {
            title: '제목',
            widthRatio: '19%',
            textAlign: 'start',
            accessor: [
                'accumulatedScore',
                'date',
                'isCanceled',
                'memo',
                'scheduleName',
                'score',
                'scoreHistoryId',
                'scoreName',
                'scoreType',
            ],
            renderCustomCell: function (_a) {
                var cellValue = _a.cellValue;
                var _b = __read(cellValue, 9), accumulatedScore = _b[0], date = _b[1], isCanceled = _b[2], memo = _b[3], scheduleName = _b[4], score = _b[5], scoreHistoryId = _b[6], scoreName = _b[7], scoreType = _b[8];
                var scoreHistory = {
                    accumulatedScore: accumulatedScore,
                    date: date,
                    isCanceled: isCanceled,
                    memo: memo,
                    scheduleName: scheduleName,
                    score: score,
                    scoreHistoryId: scoreHistoryId,
                    scoreName: scoreName,
                    scoreType: scoreType,
                };
                return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Styled.ActivityTitle, __assign({ isCanceled: isCanceled, onClick: function () {
                                return handleActivityScoreModal({
                                    key: store_1.ModalKey.activityScoreModalDialog,
                                    isOpen: true,
                                    props: {
                                        scoreHistory: scoreHistory,
                                        generationNumber: (0, utils_1.parseUrlParam)(generationNumberParam),
                                        memberId: (0, utils_1.parseUrlParam)(memberIdParam),
                                    },
                                });
                            } }, { children: scoreName }), void 0), isCanceled && (0, jsx_runtime_1.jsx)(Styled.CancelLabel, { children: "\uCDE8\uC18C" }, void 0)] }, void 0));
            },
        },
        {
            title: '세미나 정보',
            widthRatio: '20%',
            accessor: ['scheduleName', 'isCanceled'],
            renderCustomCell: function (_a) {
                var cellValue = _a.cellValue;
                var _b = __read(cellValue, 2), scheduleName = _b[0], isCanceled = _b[1];
                return ((0, jsx_runtime_1.jsx)(Styled.Column, __assign({ isCanceled: isCanceled }, { children: (0, utils_1.parsePlaceholderWhenEmpty)(scheduleName) }), void 0));
            },
        },
        {
            title: '일시',
            widthRatio: '20%',
            accessor: ['date', 'isCanceled'],
            renderCustomCell: function (_a) {
                var cellValue = _a.cellValue;
                var _b = __read(cellValue, 2), date = _b[0], isCanceled = _b[1];
                return ((0, jsx_runtime_1.jsx)(Styled.Column, __assign({ isCanceled: isCanceled }, { children: (0, utils_1.formatDate)(date, 'YYYY년 M월 D일 hh시 mm분') }), void 0));
            },
        },
        {
            title: '메모',
            widthRatio: '20%',
            accessor: ['memo', 'isCanceled'],
            renderCustomCell: function (_a) {
                var cellValue = _a.cellValue;
                var _b = __read(cellValue, 2), memo = _b[0], isCanceled = _b[1];
                return ((0, jsx_runtime_1.jsx)(Styled.MemoColumn, __assign({ isCanceled: isCanceled }, { children: (0, utils_1.parsePlaceholderWhenEmpty)(memo) }), void 0));
            },
        },
        {
            title: '점수',
            widthRatio: '7%',
            accessor: ['score', 'isCanceled'],
            renderCustomCell: function (_a) {
                var cellValue = _a.cellValue;
                var _b = __read(cellValue, 2), score = _b[0], isCanceled = _b[1];
                return ((0, jsx_runtime_1.jsx)(Styled.ScoreColumn, __assign({ type: (0, ActivityScore_1.getScoreRangeType)(score), isCanceled: isCanceled }, { children: score }), void 0));
            },
        },
        {
            title: '총 점수',
            widthRatio: '7%',
            accessor: 'accumulatedScore',
        },
    ];
    var _b = (0, recoil_1.useRecoilValue)((0, member_1.$memberDetail)({
        generationNumber: (0, utils_1.parseUrlParam)(generationNumberParam),
        memberId: (0, utils_1.parseUrlParam)(memberIdParam),
    })), name = _b.name, platform = _b.platform, identification = _b.identification, generationNumber = _b.generationNumber, totalScore = _b.totalScore, scoreHistoryResponses = _b.scoreHistoryResponses;
    return ((0, jsx_runtime_1.jsxs)(Styled.ActivityScoreDetailPage, { children: [(0, jsx_runtime_1.jsx)(components_1.BackButton, { label: "\uBAA9\uB85D \uB3CC\uC544\uAC00\uAE30", onClick: function () { return handleGoBack(constants_1.PATH.ACTIVITY_SCORE); } }, void 0), (0, jsx_runtime_1.jsx)(Styled.Headline, { children: "\uD65C\uB3D9\uC810\uC218 \uC0C1\uC138" }, void 0), (0, jsx_runtime_1.jsxs)(Styled.Row, { children: [(0, jsx_runtime_1.jsx)(ActivityScore_1.PersonalInfoCard, { name: name, platform: platform, identification: identification, generationNumber: generationNumber }, void 0), (0, jsx_runtime_1.jsx)(ActivityScore_1.ScoreCard, { totalScore: totalScore }, void 0)] }, void 0), (0, jsx_runtime_1.jsxs)(Styled.Content, { children: [(0, jsx_runtime_1.jsxs)(Styled.ContentHeader, { children: [(0, jsx_runtime_1.jsx)("h3", { children: "\uD65C\uB3D9\uC810\uC218 \uD788\uC2A4\uD1A0\uB9AC" }, void 0), (0, jsx_runtime_1.jsx)(components_1.Button, { shape: Button_component_1.ButtonShape.defaultLine, label: "\uC810\uC218 \uCD94\uAC00", Icon: plus_16_svg_1.default, "$size": "xs", onClick: function () {
                                    handleApplyActivityScoreModal({
                                        key: store_1.ModalKey.applyActivityScoreModalDialog,
                                        isOpen: true,
                                        props: {
                                            generationNumber: (0, utils_1.parseUrlParam)(generationNumberParam),
                                            memberId: (0, utils_1.parseUrlParam)(memberIdParam),
                                        },
                                    });
                                } }, void 0)] }, void 0), (0, jsx_runtime_1.jsx)(components_1.Table, { prefix: "score-history", columns: columns, rows: scoreHistoryResponses, supportBar: {} }, void 0)] }, void 0)] }, void 0));
};
exports.default = ActivityScoreDetail;
